import { useEffect, useState } from "react";
import api from "./Services/api";
import { useNavigate } from "react-router-dom";
import {
  FaSort,
  FaImages,
  FaHandHoldingHeart,
  FaSpinner,
} from "react-icons/fa";

const PublicDonationRequests = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sortLatest, setSortLatest] = useState(true);
  const limit = 100;
  const navigate = useNavigate();

  useEffect(() => {
    fetchDonations();
    // eslint-disable-next-line
  }, [sortLatest]);

  const handleDonateClick = (donationId) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    navigate(`/donate/${donationId}`);
  };

  const fetchDonations = async () => {
    setLoading(true);
    try {
      const res = await api.get("/publicview.php", {
        params: { page, limit, sort: sortLatest ? "latest" : "oldest" },
      });
      setList(res.data?.data?.donations || []);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to load donations");
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  const getPhotosArray = (photoString) => {
    if (!photoString) return [];
    return photoString
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
  };

  return (
    <div className="public-donations-page">
      {/* ── PAGE HERO ── */}
      <section className="about-hero">
        <div className="about-hero-bg" />
        <div className="container">
          <div className="about-hero-inner">
            <p className="about-eyebrow">Support a Cause</p>
            <h1>
              Donation <span>Request</span>
            </h1>
            <p className="about-hero-sub">
              Submit your request for support or contribute to our mission by
              helping those in need through the Geetha Alagappan Foundation.
            </p>
          </div>
        </div>
      </section>

      {/* ── MAIN SECTION ── */}
      <section className="pubdon-section">
        <div className="container">
          {/* Toolbar */}
          <div className="pubdon-toolbar">
            <div className="pubdon-toolbar-left">
              <p className="pubdon-eyebrow">Active Requests</p>
              {!loading && (
                <h2 className="pubdon-count">
                  {list.length}{" "}
                  <span>open request{list.length !== 1 ? "s" : ""}</span>
                </h2>
              )}
            </div>
            <div className="pubdon-toolbar-right">
              <div className="pubdon-sort-wrap">
                <FaSort className="pubdon-sort-icon" />
                <select
                  className="pubdon-sort-select"
                  value={sortLatest ? "latest" : "oldest"}
                  onChange={(e) => setSortLatest(e.target.value === "latest")}
                >
                  <option value="latest">Latest First</option>
                  <option value="oldest">Oldest First</option>
                </select>
              </div>
            </div>
          </div>

          {/* States */}
          {loading ? (
            <div className="pubdon-loading">
              <FaSpinner className="pubdon-spinner" />
              <p>Loading donation requests…</p>
            </div>
          ) : list.length === 0 ? (
            <div className="pubdon-empty">
              <FaHandHoldingHeart />
              <p>No donation requests found.</p>
            </div>
          ) : (
            <>
              {/* ── Desktop Table ── */}
              <div className="pubdon-table-wrap">
                <table className="pubdon-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Requestor</th>
                      <th>Description</th>
                      <th>Requested</th>
                      <th>Donated</th>
                      <th>Pending</th>
                      <th>Photos</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((d, index) => {
                      const photos = getPhotosArray(d.photo);
                      const pendingAmount =
                        (Number(d.requested_amount) || 0) -
                        (Number(d.total_donated) || 0);
                      const pct = d.requested_amount
                        ? Math.min(
                            100,
                            Math.round(
                              ((Number(d.total_donated) || 0) /
                                Number(d.requested_amount)) *
                                100,
                            ),
                          )
                        : 0;

                      return (
                        <tr key={d.donation_id}>
                          <td className="pubdon-td-num">{index + 1}</td>

                          <td className="pubdon-td-name">
                            <div className="pubdon-avatar">
                              {(d.requestor_name || "?")[0].toUpperCase()}
                            </div>
                            <span>{d.requestor_name || "—"}</span>
                          </td>

                          <td className="pubdon-td-desc">
                            {(d.description || "").slice(0, 90)}
                            {(d.description || "").length > 90 ? "…" : ""}
                          </td>

                          <td className="pubdon-td-amount requested">
                            ₹
                            {Number(d.requested_amount || 0).toLocaleString(
                              "en-IN",
                            )}
                          </td>

                          <td className="pubdon-td-amount donated">
                            <span>
                              ₹
                              {Number(d.total_donated || 0).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <div className="pubdon-progress">
                              <div
                                className="pubdon-progress-fill"
                                style={{ width: `${pct}%` }}
                              />
                            </div>
                            <span className="pubdon-pct">{pct}%</span>
                          </td>

                          <td className="pubdon-td-amount pending">
                            ₹{pendingAmount.toLocaleString("en-IN")}
                          </td>

                          <td className="pubdon-td-photos">
                            {photos.length > 0 ? (
                              <div className="pubdon-photos">
                                {photos.slice(0, 3).map((p, i) => (
                                  <img
                                    key={i}
                                   // src={`http://localhost/trust_site/uploads/${p}`}
                                    src={`https://geethaalagappantrust.com/trust_site/uploads/${p}`}
                                    alt="proof"
                                    className="pubdon-photo-thumb"
                                    onClick={() =>
                                      window.open(
                                        // `http://localhost/trust_site/uploads/${p}`,
                                        `https://geethaalagappantrust.com/trust_site/uploads/${p}`,
                                        "_blank",
                                      )
                                    }
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                    }}
                                  />
                                ))}
                                {photos.length > 3 && (
                                  <span className="pubdon-photo-more">
                                    +{photos.length - 3}
                                  </span>
                                )}
                              </div>
                            ) : (
                              <span className="pubdon-no-photo">
                                <FaImages /> None
                              </span>
                            )}
                          </td>

                          <td>
                            <button
                              className="pubdon-donate-btn"
                              onClick={() => handleDonateClick(d.donation_id)}
                            >
                              <FaHandHoldingHeart /> Donate
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* ── Mobile Cards ── */}
              <div className="pubdon-cards">
                {list.map((d, index) => {
                  const photos = getPhotosArray(d.photo);
                  const pendingAmount =
                    (Number(d.requested_amount) || 0) -
                    (Number(d.total_donated) || 0);
                  const pct = d.requested_amount
                    ? Math.min(
                        100,
                        Math.round(
                          ((Number(d.total_donated) || 0) /
                            Number(d.requested_amount)) *
                            100,
                        ),
                      )
                    : 0;

                  return (
                    <div className="pubdon-card" key={d.donation_id}>
                      <div className="pubdon-card-header">
                        <div className="pubdon-card-name">
                          <div className="pubdon-avatar">
                            {(d.requestor_name || "?")[0].toUpperCase()}
                          </div>
                          <div>
                            <strong>{d.requestor_name || "—"}</strong>
                            <span className="pubdon-card-index">
                              #{index + 1}
                            </span>
                          </div>
                        </div>
                        <button
                          className="pubdon-donate-btn"
                          onClick={() => handleDonateClick(d.donation_id)}
                        >
                          <FaHandHoldingHeart /> Donate
                        </button>
                      </div>

                      {d.description && (
                        <p className="pubdon-card-desc">
                          {(d.description || "").slice(0, 120)}
                          {(d.description || "").length > 120 ? "…" : ""}
                        </p>
                      )}

                      <div className="pubdon-card-amounts">
                        <div className="pubdon-amount-chip requested">
                          <span>Requested</span>
                          <strong>
                            ₹
                            {Number(d.requested_amount || 0).toLocaleString(
                              "en-IN",
                            )}
                          </strong>
                        </div>
                        <div className="pubdon-amount-chip donated">
                          <span>Donated</span>
                          <strong>
                            ₹
                            {Number(d.total_donated || 0).toLocaleString(
                              "en-IN",
                            )}
                          </strong>
                        </div>
                        <div className="pubdon-amount-chip pending">
                          <span>Pending</span>
                          <strong>
                            ₹{pendingAmount.toLocaleString("en-IN")}
                          </strong>
                        </div>
                      </div>

                      <div className="pubdon-card-progress">
                        <div className="pubdon-progress">
                          <div
                            className="pubdon-progress-fill"
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                        <span className="pubdon-pct">{pct}% funded</span>
                      </div>

                      {photos.length > 0 && (
                        <div className="pubdon-photos">
                          {photos.slice(0, 4).map((p, i) => (
                            <img
                              key={i}
                              // src={`http://localhost/trust_site/uploads/${p}`}
                              src={`https://geethaalagappantrust.com/trust_site/uploads/${p}`}
                              alt="proof"
                              className="pubdon-photo-thumb"
                              onClick={() =>
                                window.open(
                                  // `http://localhost/trust_site/uploads/${p}`,
                                  `https://geethaalagappantrust.com/trust_site/uploads/${p}`,
                                  "_blank",
                                )
                              }
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default PublicDonationRequests;
